module.exports = __webpack_public_path__ + "media/video_banner_principal.71bebb62.mp4";